/**
 * @desc 根据供应商和sku集合批量查询sku报价
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: Array<defs.srm.SupplierIdNameAndSkuDto>, options?: any) {
  return updateResponse(
    http(URL + `/batchQuotationBySupplierIdNameAndSku`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
